export const isHighlightWindowOpen = () => {
  const now = new Date();
  


  const month = now.getMonth(); // 0-11
  const date = now.getDate(); // 1-31
  // Quarters start in Jan(0), Apr(3), Jul(6), Oct(9)
  const isStartOfQuarter = [0, 3, 6, 9].includes(month);
  return isStartOfQuarter && date <= 5;
};
